export enum UserLanguageCode {
  en = 'en',
  de = 'de',
  fr = 'fr',
  es = 'es',
  pt = 'pt',
  it = 'it',
  th = 'th',
  id = 'id'
}
